import React from "react";
import { PrimaryMedium } from "@streeteasy/design-system/typography";
import { arrayOf, shape, string } from "prop-types";

import * as S from "./styled";

const RecommendedResources = ({ helpfulBlogPosts }) => (
  <S.RecommendedResourcesContainer>
    <PrimaryMedium>Master the NYC market</PrimaryMedium>
    <S.SubTitle>Articles based on your profile</S.SubTitle>
    <S.Container>
      {helpfulBlogPosts.map(({ imageUrl, shortHeadline, title, url }) => (
        <S.Card key={url}>
          <S.Link href={url}>{title}</S.Link>
          <S.Image alt="" loading="lazy" src={imageUrl} />
          <S.Content>
            <S.CardTitle>{shortHeadline}</S.CardTitle>
            <S.CardSubTitle>{title}</S.CardSubTitle>
          </S.Content>
        </S.Card>
      ))}
    </S.Container>
  </S.RecommendedResourcesContainer>
);

RecommendedResources.propTypes = {
  helpfulBlogPosts: arrayOf(
    shape({
      imageUrl: string.isRequired,
      shortHeadline: string.isRequired,
      title: string.isRequired,
      url: string.isRequired
    })
  ).isRequired
};

export default RecommendedResources;
